import React, { useState } from "react";
import UserSelectModal from "./UserSelectModal";

const UserSelector = ({ checkedKeys, onConfirm, children }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClose = () => setModalOpen(false);

  const handleConfirm = (selectedKey, checkedUsers) => {
    handleClose();
    onConfirm?.(selectedKey, checkedUsers);
  };

  const child = React.Children.only(children);

  const handleClick = e => {
    setModalOpen(true);
    child.props.onClick?.(e);
  };

  return (
    <>
      {React.cloneElement(child, {
        onClick: handleClick
      })}
      <UserSelectModal
        open={modalOpen}
        checkedKeys={checkedKeys}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default UserSelector;
